// helpers
export const getInitialTripLegs = trip_type => {
  const legsCountMap = {
    RoundTrip: 2,
    OneWay: 1,
    MultipleFlights: 2,
  };
  const count = legsCountMap[trip_type] || 1;

  const legs = [];
  for (let i = 0; i < count; i++) {
    legs.push({ origin: {}, destination: {}, date: null });
  }
  return legs;
};

const createInitialTripState = trip_type => ({
  adults_qty: 1,
  cabin_type: '',
  childs: [],
  chosen_airlines: [],
  flexible_date: false,
  id_integration: 2,
  trip_type,
  dataTripLegs: getInitialTripLegs(trip_type),
});

// construir un leg individual
const buildLeg = (leg = {}, invert = false) => {
  if (invert) {
    return {
      origin: leg.destination || {},
      destination: leg.origin || {},
      date: null,
    };
  }
  return {
    origin: leg.origin || {},
    destination: leg.destination || {},
    date: leg.date || null,
  };
};

// helper que decide cómo inicializar dataTripLegs según resetType y reglas
const initializeTripLegs = ({ resetType, originalData, airSectionRow }) => {
  if (resetType === 'OneWay') {
    if (originalData.OneWay && originalData.OneWay.dataTripLegs.length > 0) {
      return [...originalData.OneWay.dataTripLegs];
    }
    if (
      originalData.RoundTrip &&
      originalData.RoundTrip.dataTripLegs.length > 0
    ) {
      return [buildLeg(originalData.RoundTrip.dataTripLegs[0])];
    }
    if (airSectionRow && airSectionRow[0]) {
      return [buildLeg(airSectionRow[0])];
    }
    return getInitialTripLegs('OneWay');
  }

  if (resetType === 'RoundTrip') {
    if (
      originalData.RoundTrip &&
      originalData.RoundTrip.dataTripLegs.length > 0
    ) {
      return [...originalData.RoundTrip.dataTripLegs];
    }
    if (originalData.OneWay && originalData.OneWay.dataTripLegs.length > 0) {
      const oneWayLeg = originalData.OneWay.dataTripLegs[0];
      return [buildLeg(oneWayLeg), buildLeg(oneWayLeg, true)];
    }
    if (airSectionRow && airSectionRow.length === 2) {
      return [...airSectionRow];
    }
    return getInitialTripLegs('RoundTrip');
  }

  if (resetType === 'MultipleFlights') {
    // if (
    //   originalData.MultipleFlights &&
    //   originalData.MultipleFlights.dataTripLegs.length > 0
    // ) {
    //   return [...originalData.MultipleFlights.dataTripLegs];
    // }
    const res = getInitialTripLegs('MultipleFlights');

    res[0] =
      airSectionRow && airSectionRow[0] ? buildLeg(airSectionRow[0]) : res[0];
    if (airSectionRow && airSectionRow[1]) {
      //setear fecha del segundo leg igual a la del primero si no tiene fecha pero el primero sí
      if (airSectionRow[1].date) {
        res[1].date = airSectionRow[1].date;
      }
      //res[1] = buildLeg(airSectionRow[1]);
    }
    //res[1] = originalData.MultipleFlights && originalData.MultipleFlights.dataTripLegs && originalData.MultipleFlights.dataTripLegs[1] ? buildLeg(originalData.MultipleFlights.dataTripLegs[1]) : res[1];
    return res;
  }

  return getInitialTripLegs(resetType);
};

// tipos de viaje
const tripTypes = ['RoundTrip', 'OneWay', 'MultipleFlights'];

// estado inicial
const initialState = {};
tripTypes.forEach(type => {
  initialState[type] = createInitialTripState(type);
});
initialState.currentTripType = 'RoundTrip';

// reducer
const flightsSearch = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FLIGHTS': {
      const tripType = action.payload.trip_type || state.currentTripType;
      const newState = {};

      tripTypes.forEach(type => {
        if (type === tripType) {
          newState[type] = { ...state[type], ...action.payload };
        } else {
          newState[type] = createInitialTripState(type);
        }
      });

      const newOriginalData = { [tripType]: { ...newState[tripType] } };

      return {
        ...newState,
        _originalData: newOriginalData,
        currentTripType: tripType,
      };
    }

    case 'RESET_SEARCH_FLIGHTS': {
      const {
        trip_type: resetType,
        shouldReset,
        searchPax,
        flightClass,
        airSectionRow,
      } = action.payload;

      if (!shouldReset) return state;

      const originalData = { ...state._originalData };
      const currentType = state.currentTripType;

      // 🔹 Inicializa _originalData si está vacío y hay datos escritos
      if (
        !originalData[currentType] &&
        state[currentType].dataTripLegs.some(
          leg => leg.origin?.iata_code || leg.destination?.iata_code || leg.date
        )
      ) {
        originalData[currentType] = {
          ...state[currentType],
          dataTripLegs: [...state[currentType].dataTripLegs],
        };
      }

      // 🔹 Generar nuevos trip legs según reglas
      const newDataTripLegs = initializeTripLegs({
        resetType,
        originalData,
        airSectionRow,
      });

      const newOriginalData = {
        ...originalData,
        [resetType]: {
          adults_qty: searchPax.adults,
          childs: searchPax.childs,
          cabin_type: flightClass,
          dataTripLegs: newDataTripLegs,
        },
      };

      return {
        ...state,
        _originalData: newOriginalData,
        [resetType]: {
          ...createInitialTripState(resetType),
          adults_qty: searchPax.adults,
          childs: searchPax.childs,
          cabin_type: flightClass,
          dataTripLegs: newDataTripLegs,
        },
        currentTripType: resetType,
      };
    }

    default:
      return state;
  }
};

export default flightsSearch;
